import { flexRender, Row } from "@tanstack/react-table";
import { ConnectDropTarget, useDrag, useDrop } from "react-dnd";
import { ReactComponent as DragHandle } from "../../../../icons/drag_handle.svg";
import { iconStyle } from "../../stylization";
import { TableDraggableRowProps } from "./types/tableDraggableRowProps";
import { useEffect } from "react";
import './tableDraggingRow.scss';

const TableDraggableRow = ({setDragging, ...props}: TableDraggableRowProps) => {
    const [{ isFirstOver }, firstDropRef] = useDrop({
        accept: 'row',
        drop: (draggedRow: Row<any>) => props.reorderRow(draggedRow.index, 0),
        collect: monitor => ({
            isFirstOver: !!monitor.isOver()
        })
    })

    const [{ isOver }, dropRef] = useDrop({
        accept: 'row',
        drop: (draggedRow: Row<any>) => props.reorderRow(draggedRow.index, props.row.index + 1),
        collect: monitor => ({
            isOver: !!monitor.isOver()
        })
    })

    const [{ isDragging }, dragRef] = useDrag({
        collect: monitor => ({ isDragging: !!monitor.isDragging() }),
        item: () => props.row,
        type: 'row',
    })

    useEffect(() => {
        setDragging(isDragging);
    }, [isDragging, setDragging])

    const PropsSVG: React.SVGAttributes<SVGSVGElement> = {
        style: iconStyle,
        width: 24,
        height: 24,
        fill: '#999490'
    }

    const renderTrDropLine = (dropRef_: ConnectDropTarget, isOver_: boolean) => {
        return props.dragging && <tr className='tr-drop-line'><td ref={dropRef_} colSpan={100}>{isOver_ && <div className='line-isOver'></div>}</td></tr>;
    }

    return (<>
        {props.row.id === "0" && renderTrDropLine(firstDropRef, isFirstOver)}
        <tr onClick={(e) => { props.onTrClick(e, props.row) }} className={`${isDragging ? "rowDragging" : ""} ${props.hasSelectClass ? "table-RowSelected" : ""}`} >
            {props.row.getVisibleCells().map((cell) => {
                return (
                    <td key={cell.id} style={cell.id === `${cell.row.index}_actions` ? { textAlign: "right" } : undefined}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                )
            })}
            <td key={-1} style={{ padding: "0", width: "0px" }}>
                <button tabIndex={-1} className="dragButton" ref={dragRef}><DragHandle {...PropsSVG} title="przeciągnij, aby zmienić kolejność" className="tableActionsFormIcons" /></button>
            </td>
        </tr>
        {renderTrDropLine(dropRef, isOver)}
    </>
    )
}

export default TableDraggableRow;
